"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skin = void 0;
var utils_1 = require("../../utils");
var qs = require("qs");
exports.skin = function (axios) {
    return {
        // 스킨 목록 조회(페이징)
        getSkins: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/skins?" + query);
        },
        // (신) 신규 스킨 업로드
        postSkinsV2: function (request) {
            return axios.post('/skins', request.data, { params: request.params, cancelToken: request.cancelToken });
        },
        /** @deprecated (구) 신규 스킨 업로드 */
        postSkins: function (request) {
            return axios.post('/skins', request.data, { params: request.params, cancelToken: request.cancelToken });
        },
        // 스킨 배포
        putSkinsDeploy: function (request) {
            return axios.put('/skins/deploy', request.data, { cancelToken: request.cancelToken });
        },
        // 다수 스킨 사용 설정
        putSkinsUse: function (request) {
            return axios.put('/skins/use', request.data);
        },
        // (신) 스킨 상세 조회
        getSkinsSkinNoV2: function (request) {
            var url = utils_1.paramPathchange('/skins/{skinNo}', request);
            return axios.get(url, request);
        },
        /** @deprecated (구) 스킨 상세 조회 */
        getSkinsSkinNo: function (request) {
            var url = utils_1.paramPathchange('/skins/{skinNo}', request);
            return axios.get(url, request);
        },
        // (신) 사용자 업로드 스킨 수정
        putSkinsSkinNoV2: function (request) {
            var url = utils_1.paramPathchange('/skins/{skinNo}', request);
            return axios.put(url, request.data, { params: request.params, cancelToken: request.cancelToken });
        },
        /** @deprecated (구) 사용자 업로드 스킨 수정 */
        putSkinsSkinNo: function (request) {
            var url = utils_1.paramPathchange('/skins/{skinNo}', request);
            return axios.put(url, request.data, { params: request.params, cancelToken: request.cancelToken });
        },
        // 스킨 복사
        postSkinsSkinNo: function (request) {
            var url = utils_1.paramPathchange('/skins/{skinNo}', request);
            return axios.post(url, request.data, { params: request.params });
        },
        // 스킨 삭제
        deleteSkinsSkinNo: function (request) {
            var query = qs.stringify(request.params);
            var url = utils_1.paramPathchange('/skins/{skinNo}', request);
            return axios.delete(url + ("" + (query ? '?' + query : '')));
        },
        // (신) 몰별 스킨 리스트 조회
        getSkinsMallsMallNoV2: function (request) {
            var url = utils_1.paramPathchange('/skins/malls/{mallNo}', request);
            return axios.get(url, request);
        },
        /** @deprecated (구) 몰별 스킨 리스트 조회 */
        getSkinsMallsMallNo: function (request) {
            var url = utils_1.paramPathchange('/skins/malls/{mallNo}', request);
            return axios.get(url, request);
        },
        getSkinsMallsMallNoCheckLegacy: function (_a) {
            var mallNo = _a.mallNo;
            return axios.get("/skins/malls/" + mallNo + "/check-legacy");
        },
        // 스킨 저장소를 공유하고 있는 스킨 조회
        getSkinsSkinNoCopies: function (request) {
            var url = utils_1.paramPathchange('/skins/{skinNo}/copies', request);
            return axios.get(url, request);
        },
        // 스킨 다운로드
        getSkinsSkinNoDownload: function (request) {
            request.responseType = 'blob';
            var url = utils_1.paramPathchange('/skins/{skinNo}/copies', request);
            return axios.get(url, request);
        },
        // 스킨 사용 설정 (deprecated)
        putSkinsSkinNoStatus: function (request) {
            var url = utils_1.paramPathchange('/skins/{skinNo}/status', request);
            return axios.put(url, request.data);
        },
        // 스킨 페이지 목록 조회 (deprecated)
        getSkinSkinNoEditorPagesDefaultPlatform: function (request) {
            return axios.get("/skins/" + request.pathParams.skinNo + "/editor/pages/default/" + request.pathParams.platform, request);
        },
        // 몰별 스킨명 존재 유무 체크
        getSkinsMallsMallNoSkinNameExist: function (request) {
            var url = utils_1.paramPathchange('/skins/malls/{mallNo}/skin-name/exist', request);
            return axios.get(url, request);
        }
    };
};
